import { render, staticRenderFns } from "./Elevator.vue?vue&type=template&id=555a59b7"
import script from "./Elevator.vue?vue&type=script&lang=ts"
export * from "./Elevator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports